import { Navigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";

const ProtectedRoute = ({ allowed, children }) => {
  const { userType, loading } = useAuth();

  if (loading) return null; // أو <LoadingSpinner /> إذا حابب

  if (!userType) return <Navigate to="/login" replace />;
  if (!allowed.includes(userType)) return <Navigate to="/unauthorized" replace />;

  return children;
};

export default ProtectedRoute;
